import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

const MOCK_USERS = [
  {
    id: 'user-1',
    email: 'sakshi@gridcommons.org',
    name: 'Sakshi Agarwal',
    role: 'PRACTITIONER',
    organization: 'NDPHC',
    country: 'Nigeria',
    region: 'Sub-Saharan Africa',
    avatarUrl: null,
    experienceLevel: 'INTERMEDIATE',
    isCoEAlumni: true
  },
  {
    id: 'user-2',
    email: 'investor@gridcommons.org',
    name: 'Ravi Kapoor',
    role: 'INVESTOR',
    organization: 'Climate Fund',
    country: 'India',
    region: 'South Asia',
    avatarUrl: null,
    mandate: {
      regions: ['East Africa', 'South Asia'],
      technologies: ['BESS', 'Mini-grids'],
      minCapacity: 10,
      stage: ['Raising', 'Diligence']
    }
  },
  {
    id: 'user-3',
    email: 'gov@gridcommons.org',
    name: 'Dr. Amara Okafor',
    role: 'GOVERNMENT',
    organization: 'Energy Regulatory Commission',
    country: 'Kenya',
    region: 'East Africa',
    avatarUrl: null
  }
];

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check for stored session
    const storedUser = localStorage.getItem('gridcommons_user');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
    setIsLoading(false);
  }, []);

  const login = (email, password) => {
    // Mock login - find user by email
    const user = MOCK_USERS.find(u => u.email === email);
    if (user) {
      setCurrentUser(user);
      localStorage.setItem('gridcommons_user', JSON.stringify(user));
      return { success: true, user };
    }
    return { success: false, error: 'User not found' };
  };

  const logout = () => {
    setCurrentUser(null);
    localStorage.removeItem('gridcommons_user');
  };

  const switchRole = (role) => {
    if (currentUser) {
      const updatedUser = { ...currentUser, role };
      setCurrentUser(updatedUser);
      localStorage.setItem('gridcommons_user', JSON.stringify(updatedUser));
    }
  };

  const value = {
    currentUser,
    isLoading,
    isAuthenticated: !!currentUser,
    login,
    logout,
    switchRole,
    mockUsers: MOCK_USERS
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
